<template>
  <div class="singlehour0">
    <div class="singlehour1">
      <div class="h">{{sum.time}}</div>
      <Select1 :width="'-webkit-fill-available'" :defaultValue="reason" @input="updateStatus($event)"
      :class="(reason === null) ? '' : 'highlight'">
        <option :value="null">開放預約</option>
        <option v-for="res in reasons" :key="res" :value="res">{{res}}</option>
      </Select1>
    </div>
    <div class="singlehour2" v-if="page==='佔桌概況'&&storeType==='restaurant'">
      <template v-if="storeType === 'shop'">
      <div><span :style="{width: '2.5em'}">預購</span> <span class="num">{{sum.stay}}</span> 單</div>
      <div></div>
      <template v-if="sum.stay">
        <div><span :style="{color: 'var(--自取)', fontSize: '16px', fontWeight: 700}">自取</span> <span class="num">{{sum.pickup}}</span> 單</div>
        <div><span :style="{color: 'var(--宅配)', fontSize: '16px', fontWeight: 700}">宅配</span> <span class="num">{{sum.deliver}}</span> 單</div>
      </template>
      </template>
      <template  v-if="storeType!=='shop'">
      <div>{{ storeType=== 'shop'?'預購':'預約'}} <span class="num">{{sum.stay}}</span> 組</div>
      <div></div>
      <div>桌數<span class="num">{{(sum?.tables||0)}}</span>桌</div>
      <div>人數<span class="num">{{(sum?.stayNum||0)+(sum?.stayNumChild||0)}}</span>位</div>
      </template>
    </div>
    <div class="singlehour2" v-else>
      <template v-if="storeType === 'shop'">
      <div><span :style="{width: '2.5em'}">預購</span> <span class="num">{{sum.count}}</span> 單</div>
      <div></div>
      <template v-if="sum.count">
        <div><span :style="{color: 'var(--自取)', fontSize: '16px', fontWeight: 700}">自取</span> <span class="num">{{sum.pickup}}</span> 單</div>
        <div><span :style="{color: 'var(--宅配)', fontSize: '16px', fontWeight: 700}">宅配</span> <span class="num">{{sum.deliver}}</span> 單</div>
      </template>
      </template>
      <template  v-if="storeType!=='shop'">
        <div>預約 <span class="num">{{sum.count}}</span> 組</div>
        <div></div>
      </template>
      <template  v-if="storeType!=='shop'">
      <div>大人<span class="num">{{sum?.reserveNum||0}}</span>位</div>
      <div>小孩<span class="num">{{sum?.reserveNumChild||0}}</span>位</div>
      </template>
    </div>
  </div>
</template>

<script>
import { postapi } from '../../../store/fetch'
export default {
  props: ['sum', 's', 'd', 'store', 'storeType', 'page'],
  data () {
    return {
      reasons: [
        '預約額滿',
        '特殊節日僅開放電話預約',
        '活動包場'
      ]
    }
  },
  computed: {
    reason () {
      return this.sum?.reason
    }
  },
  methods: {
    async updateStatus (ev) {
      if (this.sum.reason === ev) {
      } else {
        console.log(ev, 'updateStatus')
        const r = await postapi('restaurantStatus/dt', {
          date: this.sum.date,
          time: this.sum.time,
          reason: ev,
          store: this.store
        })
        if (r) {
          this.$emit('update', ev)
        }
      }
    },
    group (h) {
      return this.sum.summary.filter(e => e.visitTime === h).length
    },
    num (h) {
      return this.sum.summary.filter(e => e.visitTime === h).map(e => (e.reserveNum || 0) + (e.reserveNumChild || 0)).reduce((a, b) => a + b, 0)
    },
    table (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '桌').map(e => e.count).reduce((a, b) => a + b, 0)
    },
    set (h) {
      return [].concat(...this.sum.summary.filter(e => e.visitTime === h).map(e => e.Orders)).filter(e => e.unit === '套').map(e => e.count).reduce((a, b) => a + b, 0)
    }
  }

}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.h {
  margin-left: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.1em;
  width: 90px;
  height: 40px;
  border: 1.5px solid var(--color-pri);
  border-radius: 3px;
}
.singlehour0 {
  display: grid;
  grid-template-columns: 1fr;
  box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  padding: 19px 28px;
  gap: 10px;
  .singlehour1 {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 10px;
  }
  .singlehour2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    font-size: 14px;
    color: #959595;
    letter-spacing: .1em;
    line-height: 16px;
    min-height: 40px;
    height: fit-content;
    &>div{
      display: flex;
      align-items: flex-end;
      vertical-align: baseline;
      &:nth-child(odd) {
        justify-content: flex-start;
      }
      &:nth-child(even) {
        justify-content: flex-end;
      }
    }
    span.num {
      display: inline-flex;
      width: 80px;
      text-align: center;
      justify-content: center;
      font-size: 20px;
      line-height: 23px;
      letter-spacing: .1em;
      color: #000;
      font-weight: 700;
    }
  }
}
</style>
